import React from 'react';

import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';
import FormViewButton from 'components/Common/Buttons/FormViewButton';

/* eslint-disable react/prop-types, react/no-unstable-nested-components */
const FormsActions = ({ permissions, settings, getOriginalPdfFileCallback, getAllocationStatementFileCallback }) => ({
  id: 'action-column',
  Header: <span>View</span>,
  Cell: ({ row }) => (
    <div>
      <div className="form-action-btn-group">
        { (window.navigator && typeof (window.navigator.msSaveOrOpenBlob) !== 'undefined')
          ? AccessControl.hasPermission(permissions, [ActivityPerms.scannedView])
            && <button
              type="button"
              title="View original PDF"
              className="btn btn-sm btn-action"
              onClick={ () => getOriginalPdfFileCallback(row.original.formId) }
              disabled={ row.original.hasPdfFile !== true }
            >
              <span className="icon icon-photo" />
            </button>
          : AccessControl.hasPermission(permissions, [ActivityPerms.scannedView])
            && row.original.formType
            && <a
              href={ `/forms/${ row.original.formType?.toLowerCase() }/${ row.original.formId }/pdf` }
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-sm btn-action"
              title="View original PDF"
              disabled={ row.original.hasPdfFile !== true }
            >
              <span className="icon icon-photo" />
            </a> }
        { row.original.hasAllocationStmnts === true && row.original.hasOriginalStmnt === true && AccessControl.hasPermission(permissions, [ActivityPerms.multiTierMgrDownloadWhs])
          && <button
            type="button"
            className="btn btn-sm btn-action"
            onClick={ () => getAllocationStatementFileCallback(row.original.formId) }
            disabled={ row.original.hasAllocationStmnts !== true && row.original.hasOriginalStmnt !== true }
            title="View witholding statement"
          >
            <span className="icon icon-share" />
          </button> }
        { ((row.original.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.electronicView, ActivityPerms.electronicValidate]))
            || (!row.original.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate])))
            && <FormViewButton
              permissions={ permissions }
              formId={ row.original.formId }
              accountId={ row.original.accountId }
              form={ row.original }
              content={ <span className="icon icon-apps" /> }
              className="btn btn-sm btn-action"
              title="View digitised version"
            /> }
      </div>
      { (row.original.beneficiaryForms != null && [...row.original.beneficiaryForms].length > 0)
        && AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate,
          ActivityPerms.electronicView, ActivityPerms.electronicValidate])
          && <div className="form-action-ben-owners">
            <div className="ben-owner-title">Attached Beneficiary Forms</div>
            { [...row.original.beneficiaryForms].map((item, key) => item != null && (
              (window.navigator && typeof (window.navigator.msSaveOrOpenBlob) !== 'undefined')
                ? <div className="form-action-btn-group" key={ item.controlId } style={ { padding: '5px 0 0' } }>
                  { AccessControl.hasPermission(permissions, [ActivityPerms.scannedView])
                  && <button
                    type="button"
                    title="View original PDF"
                    className="btn btn-sm btn-action"
                    onClick={ () => getOriginalPdfFileCallback(item.formId) }
                    disabled={ row.original.hasPdfFile !== true }
                  >
                    <span className="icon icon-photo" />
                  </button> }
                  { AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedEdit,
                    ActivityPerms.scannedValidate, ActivityPerms.electronicView, ActivityPerms.electronicValidate])
                    && <FormViewButton
                      permissions={ permissions }
                      formId={ item.formId }
                      accountId={ item.accountId }
                      form={ item }
                      content={ <span className="icon icon-apps" /> }
                      className="btn btn-sm btn-action"
                      title="View digitised version"
                    /> }
                </div> : <div className="form-action-btn-group" key={ item.controlId } style={ { padding: '5px 0 0' } }>
                  { AccessControl.hasPermission(permissions, [ActivityPerms.scannedView]) && <a
                    href={ `/forms/${ item.formType }/${ item.formId }/pdf` }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-action"
                    title="View original PDF"
                    disabled={ row.original.hasPdfFile !== true }
                  >
                    <span className="icon icon-photo" />
                  </a> }
                  { AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedEdit,
                    ActivityPerms.scannedValidate, ActivityPerms.electronicView, ActivityPerms.electronicValidate])
                    && <FormViewButton
                      permissions={ permissions }
                      formId={ item.formId }
                      accountId={ item.accountId }
                      form={ item }
                      content={ <span className="icon icon-apps" /> }
                      className="btn btn-sm btn-action"
                      title={ `${ item.originalFilename }` }
                    /> }
                </div>
            )) }
          </div> }
      { row.original.hasAllocationStmnts
        && AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedViewTree], true)
        && row.original.accountId
        && row.original.formExpectsWhs
        && row.original.hasPublishedWhs
        && row.original.whsWithinEffectiveRange === true
        && <div className="form-action-btn-group tree-button">
          <a
            href={ `/w8imystructure/${ row.original.accountId }` }
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-action"
            title="W-8IMY Structure"
          >
            <span className="icon icon-location" />
          </a>
        </div> }
    </div>
  ),
  className: 'col-7p5'
});
/* eslint-enable react/prop-types, react/no-unstable-nested-components */

export default FormsActions;
